import { useState, useEffect } from 'react';
import { IcoClose } from './common/Icons.jsx';
import styles from './MoveTabSheet.module.css';
import { useAtrasCierra } from '../lib/atras.js';

/**
 * "¿Cuántos son?" al sentar la mesa.
 *
 * Es lo primero que sabe un mesero cuando llega un grupo. Una fila de números
 * lo resuelve en un toque: con el contador de antes, sentar a tres en una
 * mesa de ocho eran cinco toques en "−". Los números grandes se tocan de pie,
 * con la tablet en una mano.
 *
 * Se puede saltar: hay mesas que se sientan y piden después, y obligar a
 * contestar para poder trabajar sería cambiar un estorbo por otro.
 */
const RAPIDOS = [1, 2, 3, 4, 5, 6, 7, 8];

export default function CuantosSonSheet({ open, table, onClose, onConfirmar }) {
  useAtrasCierra(open, onClose);
  const [n, setN] = useState(2);
  const [mas, setMas] = useState(false);

  useEffect(() => {
    if (!open) return;
    // Arranca en dos, que es la mesa más común, y no en la capacidad: una
    // mesa de ocho casi nunca se llena.
    setN(2);
    setMas(false);
  }, [open, table]);

  if (!open) return null;

  return (
    <div className={styles.scrim} role="presentation" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={styles.sheet} role="dialog" aria-modal="true">
        <div className={styles.head}>
          <div>
            <h2 className={styles.title}>¿Cuántos son?</h2>
            <p className={styles.sub}>
              {table?.name}
              {table?.seats ? ` · ${table.seats} lugar${table.seats !== 1 ? 'es' : ''}` : ''}
            </p>
          </div>
          <button className={styles.close} onClick={onClose} aria-label="Cerrar"><IcoClose size={16} /></button>
        </div>

        <div className={styles.numRow}>
          {RAPIDOS.map((k) => (
            <button
              key={k}
              className={`${styles.numBtn} ${n === k && !mas ? styles.numBtnOn : ''}`}
              onClick={() => { setN(k); setMas(false); }}
              aria-pressed={n === k && !mas}
            >
              {k}
            </button>
          ))}
        </div>

        {mas ? (
          <div className={styles.stepper}>
            <button className={styles.stepperBtn} onClick={() => setN((v) => Math.max(1, v - 1))} aria-label="Uno menos">−</button>
            <span className={styles.stepperNum}>{n}</span>
            <button className={styles.stepperBtn} onClick={() => setN((v) => Math.min(30, v + 1))} aria-label="Uno más">+</button>
          </div>
        ) : (
          <button className={styles.alternar} onClick={() => { setMas(true); setN((v) => Math.max(v, 9)); }}>
            Más de 8…
          </button>
        )}

        <div className={styles.acciones}>
          <button className="btn btn--ghost" onClick={() => onConfirmar(0)}>Ahorita no</button>
          <button className="btn btn--primary" onClick={() => onConfirmar(n)}>Sentar {n}</button>
        </div>
      </div>
    </div>
  );
}
